import { render, staticRenderFns } from "./Fotograflar.vue?vue&type=template&id=37a5516a&scoped=true"
import script from "./Fotograflar.vue?vue&type=script&lang=js"
export * from "./Fotograflar.vue?vue&type=script&lang=js"
import style0 from "./Fotograflar.vue?vue&type=style&index=0&id=37a5516a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5516a",
  null
  
)

export default component.exports